import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from'@material-ui/core/Button';
import { Trans } from 'react-i18next';
import { NavLink } from "react-router-dom";

class HeaderBar extends Component {
  componentDidMount() {
    this.interval = setInterval(() => this.setState({ time: Date.now() }), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    let currentdate = new Date(); 
    let datetime = currentdate.getDate() + "/"
                + (currentdate.getMonth()+1)  + "/" 
                + currentdate.getFullYear() + " "  
                + currentdate.getHours() + ":"  
                + (currentdate.getMinutes()<10?'0':'') + currentdate.getMinutes() + ":" 
                + (currentdate.getSeconds()<10?'0':'') + currentdate.getSeconds();

    return (
      <div className="infoBar">
        <AppBar position="fixed">
          <Toolbar>
            <div className="logoContainer">
              <NavLink className="navButton" to="/">
                <Button><img height="70px" src={process.env.PUBLIC_URL + '/img/vcst_logo.png'} alt=""/></Button>
              </NavLink>
            </div>
            <div className="titleContainer">
                <Trans>{this.props.Title}</Trans> {this.props.AdditionalTitleInfo} 
            </div>
            <div className="userInfoContainer">
                {datetime}
            </div>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

export default HeaderBar;